{
  "RESET_PASSWORD": {
    "TITLE": "Restablir la contrasenya",
    "DESCRIPTION": "Introduïu l'adreça de correu electrònic que feu servir per iniciar sessió a Chatwoot per obtenir les instruccions de restabliment de la contrasenya.",
    "GO_BACK_TO_LOGIN": "Si voleu tornar a la pàgina d'inici de sessió,",
    "EMAIL": {
      "LABEL": "Correu electrònic",
      "PLACEHOLDER": "Introduïu el vostre correu electrònic.",
      "ERROR": "Introduïu un correu electrònic vàlid."
    },
    "API": {
      "SUCCESS_MESSAGE": "L’enllaç de reinicialització de la contrasenya s’ha enviat al vostre correu electrònic.",
      "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
    },
    "SUBMIT": "Envia"
  }
}
